
import Prohead from "../Components/Prohead"
import Navbar from "./Navbar"
import Head from "./Head"
function Products()
{
    return(
        <div>
          <Navbar></Navbar>
          <Head></Head>
          <Prohead></Prohead>
        </div>
    )
}
export default Products